import styled from 'styled-components';

/** A plain content page (login, games list): one centered column. */
export const Page = styled.main`
  max-width: 560px;
  margin: 0 auto;
  padding: 16px 16px calc(24px + env(safe-area-inset-bottom));
`;

export const PageTitle = styled.h1`
  font-size: 26px;
  margin: 8px 0 16px;
`;

export const Panel = styled.section`
  padding: 16px;
  border-radius: var(--radius);
  background: var(--felt-raised);

  & + & {
    margin-top: 12px;
  }
`;

export const PanelTitle = styled.h2`
  font-size: 15px;
  margin-bottom: 10px;
  color: var(--muted);
  font-weight: 600;
`;
